import React from 'react'
import { Marker } from 'react-leaflet'
import { MapComponent, Collapse } from '@infotech/base-components'

import { customMarker, defaultPosition } from '../Form/FormFieldsLayout'

const MapWidget = ({ data }) => { 
    const container = document.querySelector(`.leaflet-container`)
    if (container) {
        container.focus = function(){} // to prevent page scrolling on clicking the map
    }

    const point = data?.point?.point
    const position = point ? [point.lat, point.lon] : null
    return <Collapse
            title="Карта"
            isOpen={true}
        >
        <div className="issue-view-map">
          <MapComponent
                zoom={16}
                maxZoom={19}
                center={position ?? defaultPosition}
            >
              {position && <Marker 
                position={position}
                icon={customMarker}
              />}
            </MapComponent>
        </div>
    </Collapse>
}

export default MapWidget